// activeEnvironmentAsset — which environment asset the build actions operate on.
//
// "Build Lighting" and "Build Navmesh" both bake against the ACTIVE environment,
// so both need the same answer to "which one is that". Before this it was
// inlined in the menubar's Build menu; the tool rail needs it too, and two
// copies of a lookup is two chances to disagree about whether a build is
// available.
//
// The id is CARRIED, not derived: liveTuneStore holds the id the server stated
// for the loaded environment. It used to be recovered by regex from the splat
// URL, which returned nothing for every org-layout URL and so reported "no
// environment loaded" for environments that were plainly loaded (ENG-999).
//
// A `?splat=<url>` deep link arrives with a URL and no id, so a miss kicks off a
// resolve against the environment list (matching the URL the server published,
// not parsing it) and the store update re-renders the callers.

import { liveTuneStore } from './liveTuneStore.js'
import { knownAssetId, ensureAssetId } from './environmentFiles.js'

/**
 * The active environment's asset id, or null when there is nothing to build
 * against (no splat loaded, or a splat that isn't a server-side asset).
 */
export function activeEnvAssetId() {
  if (typeof window === 'undefined') return null
  const env = liveTuneStore.getState()?.environment
  const splatUrl = env?.splatUrl || null
  if (!splatUrl) return null
  if (env?.assetId) return env.assetId
  const known = knownAssetId(splatUrl)
  if (known) return known
  // Not resolved yet (deep link, or a reload before the store carried it).
  // Kick it off; the store update will re-render whoever asked.
  ensureAssetId(splatUrl)
  return null
}

/** Why a build can't run right now, or null when it can. */
export function buildBlockedReason() {
  return activeEnvAssetId() ? null : 'no environment loaded'
}

export default activeEnvAssetId
